import React, { useState } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";

export const MenuItem = ({ key, href, iconClass, title }) => {
  return (
    <li key={key} className="nav-item">
      <Link to={href} className="nav-link">
        <i className={`bi ${iconClass}`}></i>
        {title}
      </Link>
    </li>
  );
};

export const MenuTitle = ({ key, title }) => {
  return (
    <li key={key} className="menu-title">
     {title}
    </li>
  );
};

export const MenuDropDownItem = ({ key, href, title }) => {
  return (
    <li key={key} className="dropdown-item">
      <Link to={href} className="dropdown-link">
        {title}
      </Link>
    </li>
  );
};

export const MenuDropdown = ({key, href, iconClass, title, children}) => {
  const [open, setOpen] = useState(false);

  return (
    <li key={key} className="nav-item dropdown">
      <Link
        to={href}
        onClick={() => setOpen(!open)}
        aria-controls={`#collapse_${title.split(" ").join("")}`}
        aria-expanded={open}
        className={`${!open ? 'collapsed':''} nav-link`}
      >
        <i className={`bi ${iconClass}`}></i>
        {title}
      </Link>
      <Collapse in={open}>
        <div id={`collapse_${title.split(" ").join("")}`}>
          <ul className="sub-nav">{children}</ul>
        </div>
      </Collapse>
    </li>
  );
};
